<template>
  <ModalFormTemplate
    :title="'Order Details - ' + table?.table_number"
    width="50rem"
    end-point=""
    icon="clock"
    :ignore-permission="true"
    :show-save="false"
    :show-save-close="false"
    @save="makeBill"
    mode="create"
    @close="handleClose"
  >
    <template #header>
        <Buttons
        caption="Make Bill"
        icon="Banknote"
        type="success"
        @click="makeBill"
        id="button-make-bill"
      />
      <!--<Buttons
        caption="Print A4 Report"
        icon="Printer"
        type="success"
        v-if="!shiftEnded"
        @click="runReport(false)"
        id="button-print-report"
      />
      <Buttons
        caption="Print Thermal Report"
        icon="ReceiptText"
        v-if="!shiftEnded"
        type="success"
        @click="runReport(true)"
        id="button-print-report"
      />
      -->
    </template>
    <template #form>
      <div class="gap-6">
        <div class="p-6 overflow-y-auto flex-1">
          <!-- Sales Summary -->
          <div class="bg-gray-50 dark:bg-gray-900 rounded-lg p-4 mb-6">
            <div class="flex justify-between">
              <h4
                class="text-lg font-medium text-gray-900 dark:text-white mb-4"
              >
                Item Name
              </h4>
              <span class="font-medium">Amount</span>
            </div>
            <div class="space-y-2">
              <template v-for="item in orderItems">
                <div class="flex justify-between">
                  <div>
                    <span class="text-gray-600 dark:text-gray-400">
                      {{ item.item_name }}
                    </span>
                    <span
                      class="ml-2 px-2 py-1 text-xs font-semibold text-white bg-blue-500 rounded-full"
                    >
                      x {{ item.quantity }}
                    </span>
                  </div>
                  <span class="font-medium">{{
                    formatNumber(item.net_total || 0)
                  }}</span>
                </div>
              </template>
              <div class="flex justify-between  bg-gray-300 dark:bg-gray-700">
                <div>
                  <span class="text-gray-600 dark:text-gray-400"> Total </span>
                </div>
                <span class="font-medium">{{
                  formatNumber(
                    orderItems.reduce(
                      (sum, item) => Number(sum) + Number(item.net_total || 0),
                      0
                    )
                  )
                }}</span>
              </div>
            </div>
          </div>

          <!-- Payment Details Grid -->
        </div>
      </div>
    </template>
  </ModalFormTemplate>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { api } from "../../../../../api/Api";
import {
  formatNumber,
} from "../../../../../utils/CommonFunctions";
import {
  CashierDuty,
  Item,
  PosStation,
  RestaurantTables,
} from "../../../../../types/models";
import Buttons from "../../../../../components/ui/form/Buttons.vue";
import ModalFormTemplate from "../../../../../components/ui/Templates/ModalFormTemplate.vue";

const emit = defineEmits<{
  (e: "close"): void;
  (e: "make-bill", table: RestaurantTables | null, items: Item[]): void;
}>();

const props = defineProps<{
  endPoint: string;
  posStation: PosStation | undefined;
  cashierDuty: CashierDuty | null;
  table: RestaurantTables | null;
}>();



const makeBill = async () => {
  emit('make-bill', props.table, orderItems.value);
};

const orderItems = ref<Item[]>([]);
const getOrderDetails = async () => {
  const response = await api.post(
    (props.endPoint.slice(-1) == "/" ? props.endPoint : props.endPoint + "/") +
      "order-items",
    {
      tables_id: props.table?.uid,
    }
  );
  if (response.success == true) {
    orderItems.value = response.data;
  }
};

const handleClose = () => {
  emit("close");
};  

onMounted(() => {
  getOrderDetails();
});
</script>
